import css from 'styled-jsx/css';

const styles = css.global`#santander-header {
  width: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

#fixed-spacer {
  width: 100%;
  height: 58px;
}

.wrapper,
.wrapper-mb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 80px;
}

.wrapper-mb {
  height: 58px;
}

.search-input {
  border: none;
  color: #444444;
  outline: none;
  padding: 0;
  padding-right: 40px;
  width: 100%;
  height: 100%;
  font-weight: 600;
  box-sizing: border-box;
  margin-top: 3px;
}

.search-input::placeholder {
  font-weight: 600;
}

.search-container {
  flex: 1;
  margin: 0 40px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  border-bottom: 3px solid #cccccc;

  display: flex;
  align-items: center;
  justify-content: flex-start;
}

#icone-lupa {
  position: absolute;
  top: calc(50% - 6px);
  right: 0;
  transform: translate(-50%, 0);
}

.wrapper.desktop {
  display: none;
}

.wrapper-mb.mobile {
  display: flex;
}

.row-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

#santander-sidebar {
  width: 100%;
  top: 58px;
  height: calc(100vh - 58px);
  max-width: 100vw;
  background: #fff;
  border-top: 1px solid #767676;
}

#santander-sidebar a {
  text-decoration: none;
}

.amp-sidebar-mask {
  display: none;
}

.sidebar-wrapper {
  margin: 0;
  padding: 0 15px;
}

.sidebar-wrapper h3 {
  margin: 32px 8px 16px 8px;
  color: #222;
  font-weight: 600;
  font-family: SantanderText;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  padding-left: 56px;
}

.sidebar-item-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  padding: 15px 8px;
  border-bottom: 1px solid #767676;

  margin: 16px 0;
}

.sidebar-item-container h4,
.sidebar-item-container > a {
  margin: 0;
  font-family: SantanderText;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #222222;
  opacity: 1;
}

.justify-start {
  justify-content: flex-start;
}

.justify-start h4 {
  margin-left: 16px;
}

.login-mb {
  height: 24px;
  width: 24px;
  position: relative;
  /* margin-left: 16px; */
}

#santander-header a {
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.margin-left-logo {
  margin-top: 4px;
  height: 25px;
  width: auto;
}

.margin-left-logo {
  margin-left: 28px;
}

.wrapper-mb.mobile.hide-header {
  display: none;
}

@media (min-width: 992px) {
  .wrapper.desktop {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  /* .wrapper.desktop a:last-of-type img {
    height: 26px;
    width: auto;
    margin-left: 40px;
  } */

  /* .wrapper.desktop a img:last-of-type {
    height: 31px;
    width: auto;
    margin-left: 40px;
  } */

  .wrapper-mb.mobile {
    display: none;
  }

  #fixed-spacer {
    height: 140px;
  }
}

/* .search-container,
#icone-lupa-mobile {
  visibility: hidden;
} */

#icone-lupa-mobile {
  /* display: none; */
  margin-right: 16px;
}

.container-mobile-header {
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 1027px;
}

.sidebar-item-container > a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.sidebar-item-container a.text-red {
  color: #c00;
}

.sidebar-ampless {
  font-family: 'Open Sans';
  position: fixed;
  top: 0;
  max-height: 100vh;
  height: 100vh;
  max-width: 80vw;
  background-color: #efefef;
  min-width: 45px;
  outline: none;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2147483647;
  -webkit-overflow-scrolling: touch;
  will-change: transform;
  left: -100%;

  transition: left 0.233s cubic-bezier(0, 0, 0.21, 1);
}

.sidebar-ampless.opened {
  left: 0;
}

.nested-menu-ampless {
  transition: transform 0.233s cubic-bezier(0, 0, 0.21, 1);
  transform: translateX(0);
}

.nested-menu-ampless.opened {
  transform: translateX(-100%);
}

.sidebar-ampless .nested-submenu-ampless {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 200%;
  overflow: visible;
  transition: left 0.233s cubic-bezier(0, 0, 0.21, 1);
}

.sidebar-ampless .nested-submenu-ampless.opened {
  display: block;
  left: 100%;
}

.sidebar-ampless .nested-menu-ampless > ul.sidebar-wrapper,
.sidebar-ampless .nested-submenu-ampless.opened .sidebar-wrapper.sub-sidebar {
  padding-right: 0;
  padding-left: 0;
}

.sidebar-ampless .nested-menu-ampless.opened > ul.sidebar-wrapper,
.sidebar-ampless.opened .sidebar-wrapper {
  padding-right: 15px;
  padding-left: 15px;
}

.sidebar-ampless .go-back {
  margin-top: 0;
}

.sidebar-ampless ul {
  list-style-type: none;
}

.sidebar-display-visible {
  display: block;
}

.sidebar-display-hidden {
  display: none;
}
`;

export default styles;